import { Record as record } from 'immutable';

import validation from '../../validation';
import ValidationMixin from '../ValidationMixin';
import { toPounds, toPence } from '../../helpers/Currency';

const defaults = {
    basketTotal: 0,
    vouchersTotal: 0,
    maxVoucherAmount: 0,
    voucherAmount: '0',
    useVouchers: true
};


class VoucherForm extends record(defaults) {

    static fromJSON (json = {}) {
        return new VoucherForm(json);
    }

    getSchema () {
        return {
            voucherAmount: validation.voucherAmount(toPounds(this.maxVoucherAmount))
        };
    }

    setVouchersTotal (vouchersTotal, preAuthedAmount) {
        return this._recalculate({ vouchersTotal, preAuthedAmount });
    }

    setBasketTotal (basketTotal) {
        return this._recalculate({ basketTotal });
    }

    get voucherAmountPence () {
        return parseFloat(toPence(this.voucherAmount));
    }

    _recalculate ({ vouchersTotal = this.vouchersTotal, basketTotal = this.basketTotal, preAuthedAmount = 0 }) {
        const allVoucherTotal = vouchersTotal + preAuthedAmount;
        const maxVoucherAmount = Math.min(allVoucherTotal, basketTotal);

        const voucherAmountPence = this.voucherAmountPence || preAuthedAmount;
        const voucherTotalChanged = allVoucherTotal !== this.vouchersTotal;
        let { voucherAmount } = this;
        if (preAuthedAmount && preAuthedAmount < allVoucherTotal) {
            voucherAmount = toPounds(preAuthedAmount).toFixed(2);
        } else if (voucherAmountPence > maxVoucherAmount || (!voucherAmountPence && voucherTotalChanged)) {
            voucherAmount = toPounds(maxVoucherAmount).toFixed(2);
        }

        return this.merge({
            basketTotal,
            vouchersTotal: allVoucherTotal,
            maxVoucherAmount,
            voucherAmount
        });
    }

}


Object.assign(VoucherForm.prototype, ValidationMixin);


export default VoucherForm;



// WEBPACK FOOTER //
// ./src/records/payment/VoucherForm.js